import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Pane, Flex, Text, TabPane, Content } from '@leverege/ui-elements'

import { WarningPanel } from '~/views'
import Editor from '../../editors/enums'
import Loader from './Loader'
import EnumValues from './EnumValues'

import S from './EnumItemScreen.css'

function EnumItemScreen( props ) {
  const { actions, item, dispatch, status, error, enumType } = props
  const [ activeTab, setActiveTab ] = useState( 'values' )
  const [ activeValue, setActiveValue ] = useState()
  useEffect( () => {
    const loadData = async () => {
      dispatch( actions( enumType ).get() )
      dispatch( actions( enumType ).values() )
    }
    loadData()
  }, [] )

  const editorData = activeTab === 'values' ? activeValue : {
    showTitle : false,
    enumType : item?.type,
    type : 'enum',
    itemActions : actions,
    full : true }

  if ( status === 'loading' ) {
    return <Pane className={S.screen}><Loader /></Pane>
  }

  if ( error && !item ) {
    return (
      <WarningPanel
        title="Oh, sprockets."
        code={error.statusCode}
        subtitle="I couldn't retrieve that enum"
        message={error.message} />
    )
  }

  let tabContent
  if ( activeTab === 'info' ) {
    tabContent = (
      <>
        {Editor.createEditor( {
          showTitle : false,
          enumType : item?.type,
          type : 'enum',
          itemActions : actions,
          full : true }
        )}
        <Pane className={S.item}>
          <Flex className={S.itemHeader} direction="column" align="flex-start">
            <Text variant="captionSmall">Enum Type</Text>
            <Text variant="subtitle">{item.type}</Text>
          </Flex>
        </Pane>
      </>
    )
  } else {
    tabContent = <EnumValues actions={actions} enumType={enumType} values={item?.values} />
  }
  return (
    <Content>
      <Content.Header>
        <TabPane className={S.tabs} activeTab={activeTab} onTabClicked={( { value } ) => setActiveTab( value )}>
          <TabPane.Tab tabName="Info" tabId="info"/>
          <TabPane.Tab tabName="Values" tabId="values"/>
        </TabPane>
      </Content.Header>
      <Content.Area>
        {tabContent}
      </Content.Area>
    </Content>
  )
}

export default connect( ( ( state, props ) => {
  const { get, actions, enumType } = props
  return {
    item : get( state ) || {},
    status : actions( enumType ).getStatus( state ),
    error : actions( enumType ).getError( state )
  }
} ) )( EnumItemScreen )
